<template>
    <!-- 内容区域 -->
    <div>
          <el-form ref="form" :model="form"  label-width="100px">
            <el-row :gutter="10" class="mb8">
              <el-col :span="16">
                <el-form-item label="名称" prop="realName">
                  <el-input v-model="form.name" placeholder="请输入知识库名称" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="最后修改时间" prop="lastUpdatedAt">
                 <a >{{ form.lastUpdatedAt }}</a>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="客服风格" prop="email">
              <el-select v-model="form.openAiTemp" placeholder="请选择"  style="width: 610px;" @change="handleChange_openaITemp"
              :popper-append-to-body="false"> <!-- 解决弹框覆盖问题 -->
          <el-option
            v-for="item in openAiTemps" :key="item.id"
            :label="item.label"
            :value="item.value"
            style="white-space: normal; line-height: 1.4; padding: 8px 12px;"> <!-- 让选项文本换行 -->
          </el-option>
         </el-select>
            </el-form-item>
            </el-form>
  </div>
  </template>

  <script>
import { getKbWorkspaceDetails, updateKbWorkspace } from '@/api/aics/kbWorkspace';
import {formatDatefromTimestamp } from '@/util/date';
  export default {
    name: "KbWorkspaceSetting",
    props: {
        slug:{
          type: String,
          value: ''
        }
       },
    data() {
      return {
        form: {
          name: "",
          lastUpdatedAt: "",
          openAiTemp: 0.4, //客服防风格选型
        },
        openAiTemps: [ //客服防风格选型
          {
            id: 1,
            label: " 规范型（追求极致准确和一致性。回答严谨专业，尽可能遵循知识库，适合用于金融、政务、技术支持等容错率极低的场景。）",
            value: 0.2
          },
          {
            id: 2,
            label: " 专业型（在保证信息准确的前提下，语气更友好自然。适用于大多数电商、服务和咨询场景，能有效提升用户好感度。）",
            value: 0.4
          },
          {
            id: 3,
            label: " 体贴型（更注重情感沟通和用户体验。回答更具安抚性和支持性，适合处理客户投诉、售前咨询或需要高情感投入的品牌。）",
            value: 0.7
          }
        ],


      }
    },
    mounted() {
      getKbWorkspaceDetails(this.slug).then(res => {
        console.log("getKbWorkspaceDetails - 响应:", res.data);
        this.form.name = res.data.workspace[0].name;
        this.form.lastUpdatedAt = formatDatefromTimestamp(res.data.workspace[0].lastUpdatedAt);
        this.form.openAiTemp = res.data.workspace[0].openAiTemp;
        console.log("this.form:", this.form);
        //this.form = res.data.data;
      });
    },
    methods: {
      validateForm() {
       if(this.form.name === ""){
          this.$message.error("名称不能为空");
          return false; // 阻止表单提交
       }
       if(this.form.name.length > 100){
          this.$message.error("名称不能超过100个字符");
          return false; // 阻止表单提交
       }
       return true;
      },
      handleChange_openaITemp(val) {
        console.log("handleChange_openaITemp", val);
        this.form.openAiTemp = val;
      },
      submitForm() {
        console.log("this.form:", this.form);
        if(this.validateForm()){

          updateKbWorkspace(this.slug, this.form).then(res => {
            console.log("updateKbWorkspace - 响应:", res);
            if (res.code === 200) {
              this.$message.success("设置成功");
              // 触发父组件的事件
              this.$emit('submit-success', true);
              return true;
            }else{
              this.$message.error("失败失败:"+res.data.msg);
              this.$emit('submit-success', false);
              return false;
            }
          }).catch(error => {
            console.error("修改失败:", error);
            this.$message.error("修改失败");
            this.$emit('submit-success', false);
            return false;
        });
      }else {
        this.$emit('submit-success', false);
        return false;
      }
    }
  }
}
  </script>
  <style scoped>
/* 确保Element UI样式正确加载 */
:deep(.el-select .el-input .el-select__caret) {
  font-family: element-icons !important;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
}

/* 解决选项被覆盖的问题 */
:deep(.el-select-dropdown) {
  z-index: 9999 !important;
}

/* 让选项文本正常换行 */
:deep(.el-select-dropdown__item) {
  white-space: normal !important;
  line-height: 1.4 !important;
  padding: 8px 12px !important;
  height: auto !important;
  min-height: 34px !important;
}
</style>

